import { render, staticRenderFns } from "./AccordionDiagnosticosSocioambientaisCertificacao.vue?vue&type=template&id=e948c9b4&lang=pug"
import script from "./AccordionDiagnosticosSocioambientaisCertificacao.vue?vue&type=script&lang=js"
export * from "./AccordionDiagnosticosSocioambientaisCertificacao.vue?vue&type=script&lang=js"
import style0 from "./AccordionDiagnosticosSocioambientaisCertificacao.vue?vue&type=style&index=0&id=e948c9b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports